import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ReceptionVisitHistoryPanel from '../panels/ReceptionVisitHistoryPanel';
import { ReceptionPageHeader } from '../ui';

export default function ReceptionReportingPage() {
  const { toast } = useOutletContext();
  return (
    <div className="recv-dash-pro recv-dash-pro--main">
      <ReceptionPageHeader
        badge="Analyse"
        title="Reporting & historique"
        description="Explorez les passages par période, société ou filière pour vos exports et bilans."
      />
      <ReceptionVisitHistoryPanel toast={toast} />
    </div>
  );
}
